export const REQUIRED_MESSAGE = "This field cannot be empty";
export const PATTERN_PASSWORD_MESSAGE =
  "The password must contain at least 8 and maximum 25 characters";
export const PATTERN_EMAIL_MESSAGE = "Please enter a valid email address";
export const PATTERN_URL_MESSAGE = "Invalid address";
